import { companyInfoSchema } from './company-info.schema';
import { purchaseOrderHistoryItemSchema } from './purchase-order-history-item.schema';
import { companyProductsSchema } from './company-products.schema';
import { companyTypeSchema } from '../../../schemas/company-type.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const companySchema = z.object({
  name: z.string().min(1),
  alias: z.string().min(1),
  externalAccountId: z.string().optional(),
  accountType: companyTypeSchema,
  companyInfo: companyInfoSchema,
  products: companyProductsSchema.optional(),
  purchaseOrderHistory: z.array(purchaseOrderHistoryItemSchema).optional(),
  testingAccount: z.boolean().optional(),
  expirationDate: coercedDate.optional(),
  dotNumber: z.string().optional(),
});

export type Company = z.infer<typeof companySchema>;
